/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OWEventTypeBody
 */
export interface OWEventTypeBody {
    /**
     * Game ID as string
     * @type {string}
     * @memberof OWEventTypeBody
     */
    game?: string;
    /**
     * The name of the event type (e.g., "KILL", "DEATH")
     * @type {string}
     * @memberof OWEventTypeBody
     */
    name: string;
    /**
     * The structure/schema of the event data
     * @type {object}
     * @memberof OWEventTypeBody
     */
    dataStructure: object;
    /**
     * Whether the event data must match the dataStructure exactly or partially
     * @type {boolean}
     * @memberof OWEventTypeBody
     */
    partialMatch: boolean;
}

/**
 * Check if a given object implements the OWEventTypeBody interface.
 */
export function instanceOfOWEventTypeBody(value: object): value is OWEventTypeBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('dataStructure' in value) || value['dataStructure'] === undefined) return false;
    if (!('partialMatch' in value) || value['partialMatch'] === undefined) return false;
    return true;
}

export function OWEventTypeBodyFromJSON(json: any): OWEventTypeBody {
    return OWEventTypeBodyFromJSONTyped(json, false);
}

export function OWEventTypeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWEventTypeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'game': json['game'] == null ? undefined : json['game'],
        'name': json['name'],
        'dataStructure': json['dataStructure'],
        'partialMatch': json['partialMatch'],
    };
}

export function OWEventTypeBodyToJSON(json: any): OWEventTypeBody {
    return OWEventTypeBodyToJSONTyped(json, false);
}

export function OWEventTypeBodyToJSONTyped(value?: OWEventTypeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'game': value['game'],
        'name': value['name'],
        'dataStructure': value['dataStructure'],
        'partialMatch': value['partialMatch'],
    };
}

